import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { PhysicalControlGroupLayout, PhysicalControlGroupStatus, PhysicalInventoryControlGroup, PhysicalInventoryDetails } from '../../../../modules/inventory/models/physical-inventory-details';
import { ApiEndpoints, PageNames, Routes } from '../../../../utils/app-constants';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageBody } from '../../../../components/page-components/PageBody';
import { Table } from '../../../../components/tables/Table';
import { NavLink } from 'react-router-dom';
import { InventorySvc } from '../../../../shared/services/inventory-service';
import { StatusCode } from '../../../../utils/api';
import { navigateToPage } from '../../../../utils/history';
import { InventoryBookDocument } from '../../../../modules/inventory/models/inventory-book-document';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';


export const InventoryPhysicalControlGroupsScene = (props: IBaseSceneProps) => {

    const dispatch = useDispatch();

    const [service] = React.useState(new InventorySvc());
    const [inventoryDetails, setInventoryDetails] = React.useState(new PhysicalInventoryDetails());

    async function getDetails(id: string) {

        if (id) {
            const result = await service.getPhysicalReportDetails(id);
            if (result.status === StatusCode.Success) {
                setInventoryDetails(result.data);
                return;
            }
        }
        else {
            navigateToPage(ApiEndpoints.INVENTORY_PHYSICAL_REPORTS);
        }
    }

    React.useEffect(() => {
        getDetails(getId());
    }, []);

    function getId() {
        const opts = props.location.pathname.split('/');
        return opts[4];
    }

    const onDownloadBookClick = () => {
        const req = new InventoryBookDocument(inventoryDetails.id, inventoryDetails.name);
        dispatch(getDocumentHelper(req));
    };

    const getButtons = () => {

        return <HasPermission requiredPermissions={[
            Permissions.InventoryPhysicalControlGroupsView
        ]}>
        <button className="btn new attention" onClick={onDownloadBookClick}>
            DOWNLOAD BOOK
        </button>
        </HasPermission>;
    }

    const getClassName = (status: PhysicalControlGroupStatus) => {

        var className = "";

        switch (status) {
            case PhysicalControlGroupStatus.complete:
                className = "complete";
                break;
            case PhysicalControlGroupStatus.inProgress:
                className = "in-progress";
                break;
            case PhysicalControlGroupStatus.notStarted:
            default:
                className = "not-started";
                break;
        }

        return 'inventory-report-status ' + className;
    }

    const getStatusName = (status: PhysicalControlGroupStatus) => {
        switch (status) {
            case PhysicalControlGroupStatus.complete:
                return 'COMPLETE';
            case PhysicalControlGroupStatus.inProgress:
                return 'IN PROGRESS';
            case PhysicalControlGroupStatus.notStarted:
            default:
                return 'NOT STARTED';
        }
    }

    return <PageContent pageName={PageNames.INVENTORY_PHYSICAL_CONTROL_GROUPS.formattify(inventoryDetails.id)} classes='inventory-physical'>
        <PageBody>
            <div className="row">
                <div className="col">
                    {getButtons()}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Table
                        header={[
                            'Control Id',
                            'Service Center',
                            'Control Name',
                            'Entry 1',
                            'Entry 2',
                            ''
                        ]}
                        noResultsMessage="No control groups in the report">
                        {
                            inventoryDetails.controlGroups.map((itm: PhysicalInventoryControlGroup, idx: number) => {
                                return <tr>
                                    <td> {itm.controlNumber} </td>
                                    <td> {itm.serviceCenter} </td>
                                    <td> {itm.name} </td>
                                    <td>
                                        {
                                            itm.layout == PhysicalControlGroupLayout.vertical
                                                ? <NavLink to={Routes.INVENTORY_PHYSICAL_VERTICAL_ENTRIES.formattify(inventoryDetails.id, itm.controlNumber, 1)} className={getClassName(itm.entry1Status)} >
                                                    {getStatusName(itm.entry1Status)}
                                                </NavLink>
                                                : <NavLink to={Routes.INVENTORY_PHYSICAL_HORIZONTAL_ENTRIES.formattify(inventoryDetails.id, itm.controlNumber, 1)} className={getClassName(itm.entry1Status)} >
                                                    {getStatusName(itm.entry1Status)}
                                                </NavLink>
                                        }
                                    </td>
                                    <td>
                                        {
                                            itm.layout == PhysicalControlGroupLayout.vertical
                                                ? <NavLink to={Routes.INVENTORY_PHYSICAL_VERTICAL_ENTRIES.formattify(inventoryDetails.id, itm.controlNumber, 2)} className={getClassName(itm.entry2Status)} >
                                                    {getStatusName(itm.entry2Status)}
                                                </NavLink>
                                                : <NavLink to={Routes.INVENTORY_PHYSICAL_HORIZONTAL_ENTRIES.formattify(inventoryDetails.id, itm.controlNumber, 2)} className={getClassName(itm.entry2Status)} >
                                                    {getStatusName(itm.entry2Status)}
                                                </NavLink>
                                        }
                                    </td>
                                    <td>
                                        {
                                            itm.hasConflicts
                                                ? <NavLink to={Routes.INVENTORY_PHYSICAL_DETAILS_CONFLICTS.formattify(getId(), itm.controlNumber)} className="inventory-report-status conflicts" >
                                                    CONFLICTS
                                                </NavLink>
                                                : null
                                        }
                                    </td>
                                </tr>
                            })
                        }
                    </Table>
                </div>
            </div>
        </PageBody>
    </PageContent >
}